import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { Loading } from "../../assets/imgs";
import {
  loadAuth,
  loadSituation,
} from "../../utils/apiFunctions/auth";
import Cookies from "js-cookie";

export default function Quotes() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    loadAuth(handleAuth);
    loadSituation(handleSituation);

    // simula o tempo de carregamento
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  function handleAuth(auth: boolean) {
    if (!auth) {
      localStorage.removeItem("user");
      navigate("/login");
    }
  }

  function handleSituation(data?: any) {
    if (data?.situation !== "Pago") {
      navigate("/dashboard/myAccount");
    }
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.origin !== "https://ruralbusiness.com.br") return;

      const iframeHeight = event.data;
      if (iframeRef.current) {
        iframeRef.current.style.height = `${iframeHeight}px`;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const iframeUrl = `https://web.ruralbusiness.com.br/embed/cotacoes?token=${Cookies.get("x-access-token")}&style=${encodeURIComponent(JSON.stringify({ height: 820 }))}`;

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ borderRadius: "15px" }}
      height="100%"
      maxWidth={1056}
      mx="auto"
      mb={6}
    >
      <Grid item width="100%" xs={12} sx={{ overflow: "hidden" }}>
        {loading ? (
          <Loading />
        ) : (
          <iframe
            ref={iframeRef}
            src={iframeUrl}
            width="100%"
            height="820px"
            scrolling="no"
            style={{ maxWidth: "1024px", overflowY: "hidden" }}
            title="Cotações"
          ></iframe>
        )}
      </Grid>
    </Grid>
  );
}
